module.exports = __webpack_public_path__ + "static/media/2_file_import_requirements_and_best_practices.ab1d346d.png";